export const VIEWPORT_MOBILE = "viewportSmall";
